import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "edit-page-100" }
const _hoisted_2 = { class: "card border-0 background-fb" }
const _hoisted_3 = { class: "edit-header" }
const _hoisted_4 = {
  key: 0,
  class: "card-body"
}
const _hoisted_5 = {
  key: 1,
  class: "card-body d-flex flex-column align-items-center justify-content-center overflow-auto"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = { class: "margin-top-3 min-height-25" }
const _hoisted_9 = { class: "d-flex flex-row" }
const _hoisted_10 = {
  key: 0,
  class: "loader-25 margin-left-3"
}
const _hoisted_11 = ["src"]
const _hoisted_12 = { style: {"min-height":"20px"} }
const _hoisted_13 = {
  key: 2,
  class: "card-body d-flex flex-column align-items-center justify-content-center overflow-auto"
}
const _hoisted_14 = {
  key: 0,
  class: "d-flex flex-row align-items-center"
}
const _hoisted_15 = {
  key: 0,
  class: "loader-25 margin-left-3"
}
const _hoisted_16 = ["src"]
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { key: 2 }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { class: "d-flex flex-column margin-top-10" }
const _hoisted_22 = {
  key: 3,
  class: "card-body d-flex flex-column align-items-center justify-content-center overflow-auto"
}
const _hoisted_23 = {
  class: "overflow-auto margin-top-10",
  style: {"padding":"20px"}
}
const _hoisted_24 = {
  class: "d-flex align-items-center",
  style: {"min-width":"250px"}
}
const _hoisted_25 = {
  key: 0,
  class: "d-flex align-items-center margin-left-20"
}
const _hoisted_26 = {
  key: 1,
  class: "d-flex align-items-center margin-left-20"
}
const _hoisted_27 = { class: "d-flex align-items-center margin-left-20" }
const _hoisted_28 = ["id", "onUpdate:modelValue"]
const _hoisted_29 = ["for"]
const _hoisted_30 = {
  key: 2,
  class: "margin-left-20 d-flex align-items-center"
}
const _hoisted_31 = {
  key: 0,
  class: "d-flex flex-row flex-fill full-size"
}
const _hoisted_32 = { class: "col-md-3" }
const _hoisted_33 = { class: "left-tabs overflow-auto" }
const _hoisted_34 = { class: "font-size-14" }
const _hoisted_35 = { class: "col-md-9 overflow-y" }
const _hoisted_36 = { class: "card-body overflow-y padding-0" }
const _hoisted_37 = { class: "d-flex flex-row justify-content-between padding-lr align-items-center marg" }
const _hoisted_38 = { class: "min-height-40" }
const _hoisted_39 = ["src", "alt"]
const _hoisted_40 = {
  key: 0,
  class: "margin-top-10"
}
const _hoisted_41 = { class: "float-right margin-top-10" }
const _hoisted_42 = ["disabled"]
const _hoisted_43 = { key: 1 }
const _hoisted_44 = {
  key: 5,
  class: "card-body overflow-auto d-flex flex-column justify-content-center align-items-center"
}
const _hoisted_45 = { class: "max-width-40" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_47 = { class: "margin-top-10" }
const _hoisted_48 = { class: "color-purple" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_50 = { class: "margin-top-10" }
const _hoisted_51 = { class: "justify-content-center" }
const _hoisted_52 = { class: "color-purple" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_54 = { class: "margin-top-10" }
const _hoisted_55 = {
  key: 0,
  class: "margin-top-10"
}
const _hoisted_56 = { class: "color-purple" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_58 = { class: "d-flex align-items-center margin-top-10" }
const _hoisted_59 = {
  for: "go-flow-check",
  class: "margin-left-3 d-flex align-items-center"
}
const _hoisted_60 = { class: "card-footer footer" }
const _hoisted_61 = { class: "d-flex flex-row justify-content-between align-items-center" }
const _hoisted_62 = {
  key: 0,
  class: "font-size-14"
}
const _hoisted_63 = { class: "color-purple" }
const _hoisted_64 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_65 = {
  key: 1,
  class: "justify-content-center font-size-14"
}
const _hoisted_66 = { class: "color-purple" }
const _hoisted_67 = { class: "loader-div-40" }
const _hoisted_68 = ["src"]

import { ElStep, ElSteps, ElButton, ElSelect, ElOption } from "element-plus";
import { computed, defineAsyncComponent, onBeforeMount, ref, watch } from "vue";
import i18n from "@/core/i18n/i18n";
import { currentRoute, router } from "@/core/router";
import {
  getFlow,
  verifyConnectors,
  exportFlow,
  checkFlowNameExists,
} from "@/flow/services/flow.service";
import {
  hasPermission,
  authInfo,
  setSelectedOrganizationRole,
} from "@/core/auth";
import { getOrganizationsByUserId } from "@/user/services/user.service";
import {
  getOrganizationsConnectorList,
  getOrganizationConnectionList,
  StepConnection,
} from "@/connection/services/connection.service";
import { showConfirm, showAlert } from "@/core/popup";
import { ASSETS_BASE_URL, DEFAULT_LOGO, getResolution } from "@/core/logo";
import { findOrganizationRoleByOrgId } from "@/core/auth/user-role";
import { getAllSteps } from "@/flow/utils/getAllSteps";
import { TYPE } from "vue-toastification";


export default /*#__PURE__*/_defineComponent({
  __name: 'ExportWizard',
  setup(__props) {

const { t } = i18n.global;

const ConnectionForm = defineAsyncComponent(
  () => import("@/connection/components/ConnectionForm.vue")
);

const pageLoading = ref(false);

const flowId = currentRoute.value.params.id as string;

const version = currentRoute.value.params.version as string;

const flowError = ref(false);

const active = ref(0);

const selectedFlow = ref();

const loading = ref(false);

const userError = ref(false);

const organizations = ref([]);

const organizationConnections = ref([]);

const selectedOrganizationConnections = ref([]);

const organizationError = ref(false);

const verifying = ref(false);

const verifyError = ref(false);

const stepConnectionList = ref(new Array<StepConnection>());

const connectorList = ref([]);

const newConnectionLoading = ref(false);

const selectedStepConnectionIndex = ref();

const exportResponseLoading = ref(false);

const exportResult = ref();

const isFinished = ref(false);

const flowNameExists = ref("");

const flowNameLoading = ref(false);

const goEdit = ref(true);

const connectionList = computed(() => filterConnections());

const isStepsValid = computed(() => {
  switch (active.value) {
    case 0:
      return (
        selectedOrganization.value !== undefined &&
        !flowError.value &&
        !organizationError.value &&
        flowNameExists.value === "NOT_EXIST"
      );
    case 1:
      return isConnectorsValid.value.verified;
    case 2:
      return isStepListValid.value;
    case 3:
      return (
        createConnectionList.value.length === 0 || isCreateConnectionValid.value
      );
    case 4:
      return !isFinished.value;
    default:
      return true;
  }
});

const isConnectorsValid = ref({
  verified: false,
  list: [],
  connectionOptionalSpecIds: [] as string[],
});

// Bumped by every connector verify so a slow response for a previously selected organization
// cannot overwrite the current selection's result.
let verifyRequest = 0;

async function verifyConnectorsForSelection(): Promise<{
  current: boolean;
  response: any;
}> {
  verifyRequest += 1;
  const request = verifyRequest;
  const response = await verifyConnectors(flowId, selectedOrgId.value);
  return { current: request === verifyRequest, response };
}

const selectedCreateConnection = ref<StepConnection>({
  stepId: "",
  stepName: "",
  specId: "",
  requiresCreate: false,
  connectionId: "",
  addNew: false,
  connection: undefined,
  nameExists: false,
  uniqueConnection: false,
  selectedName: "",
});

const selectedOrgId = ref("");

const createConnectionList = computed(() =>
  hasPermission("CONNECTIONS.LIST.CREATE")
    ? stepConnectionList.value.filter(
        (element) => element.requiresCreate || element.addNew
      )
    : []
);

const connectionRequiredSteps = computed(() =>
  stepConnectionList.value.filter(
    (item) => !item.isVirtualStep && !item.connectionOptional
  )
);

const selectedOrganization = computed(() =>
  organizations.value.find((org) => org.id === selectedOrgId.value)
);

const isStepListValid = computed(() => {
  let check = true;
  stepConnectionList.value.forEach((item) => {
    if (
      !item.isVirtualStep &&
      !item.connectionOptional &&
      !item.connectionId &&
      !item.requiresCreate &&
      !item.addNew
    ) {
      check = false;
    }
  });
  return check;
});

const isCreateConnectionValid = ref(false);

function setActive(value: number): void {
  if (active.value < value) {
    if (isStepsValid.value) {
      active.value = value;
    }
  } else if (active.value > value) {
    active.value = value;
  }
}

function next() {
  if (isStepsValid.value) {
    if (active.value === 3) {
      if (
        createConnectionList.value.length > 0 &&
        !isCreateConnectionValid.value
      ) {
        return;
      }
      if (
        selectedStepConnectionIndex?.value <
        createConnectionList?.value?.length - 1
      ) {
        nextConnection();
        return;
      }
    }
    if (active.value + 1 < 5) {
      active.value++;
    }
  }
}

function previous() {
  if (active.value - 1 > -1) {
    if (active.value === 4 && createConnectionList.value.length === 0) {
      active.value = 2;
    } else {
      active.value--;
    }
  }
}

function nextConnection() {
  if (
    selectedStepConnectionIndex.value <
    createConnectionList.value.length - 1
  ) {
    selectedStepConnectionIndex.value++;
    selectedCreateConnection.value =
      createConnectionList.value[selectedStepConnectionIndex.value];
  }
}

function previousConnection() {
  if (selectedStepConnectionIndex.value - 1 > -1) {
    selectedStepConnectionIndex.value--;
    selectedCreateConnection.value =
      createConnectionList.value[selectedStepConnectionIndex.value];
  }
}

function checkChange() {
  createConnectionList.value.forEach((item) => {
    if (item.selectedName) {
      const conn = connectionList.value.find(
        (connection) => connection.name === item.selectedName
      );
      if (!conn) {
        item.selectedName = "";
        item.connection = undefined;
      }
    }
  });
}

function updateConnection(index: number, stepConnection: StepConnection): void {
  stepConnection.uniqueConnection = true;
  selectedCreateConnection.value.selectedName = "";
  stepConnection.connection.idx = index;
  createConnectionList.value.splice(index, 1, stepConnection);
  selectedCreateConnection.value = stepConnection;
  checkChange();
}

function updateCreateConnectionValid(valid) {
  isCreateConnectionValid.value = valid;

  if (
    valid &&
    selectedStepConnectionIndex.value < createConnectionList.value.length - 1
  ) {
    isCreateConnectionValid.value = false;
    selectedStepConnectionIndex.value++;
    selectedCreateConnection.value =
      createConnectionList.value[selectedStepConnectionIndex.value];
  }
}

async function cancel() {
  if (active.value === 0) {
    await router.push("/flows");
  } else {
    const isConfirmed = await showConfirm(
      "warning",
      "Exit",
      t("Flow.ExitFromPage")
    );
    if (isConfirmed) {
      await router.push("/flows");
    }
  }
}

function filterConnections() {
  const list = [];
  createConnectionList.value.forEach((item) => {
    if (item.connection && !item.selectedName) {
      list.push(JSON.parse(JSON.stringify(item.connection)));
    }
  });
  return list.filter(
    (value, index, array) =>
      index ===
      array.findIndex((val) => JSON.stringify(val) === JSON.stringify(value))
  );
}

async function finishExportWizard() {
  exportResponseLoading.value = true;
  const response = await exportFlow({
    flowId: selectedFlow.value.id,
    organizationId: selectedOrganization.value.id,
    stepConnectionDtoList: stepConnectionList.value,
  });
  if (response) {
    exportResult.value = response;
    showAlert(TYPE.SUCCESS, t("Flow.ExportWizardSuccess"));
    if (goEdit.value) {
      moveExportedFlowPage(response);
    } else {
      router.push("/flows");
    }
  } else {
    showAlert(TYPE.WARNING, t("Flow.ExportWizardFailure"));
  }
  exportResponseLoading.value = false;
}

function moveExportedFlowPage(exportedFlowId) {
  const selectedOrgRole = findOrganizationRoleByOrgId(
    selectedOrganization.value.id
  );
  if (selectedOrgRole) {
    setSelectedOrganizationRole(
      selectedOrgRole,
      `/flows/edit/${exportedFlowId}/${1}`
    );
  }
}

function checkNameExists(value) {
  selectedCreateConnection.value.nameExists = false;
  selectedOrganizationConnections.value.forEach((connection) => {
    if (
      connection.name.toLowerCase().replaceAll(" ", "") ===
      value.name.toLowerCase().replaceAll(" ", "")
    ) {
      selectedCreateConnection.value.nameExists = true;
    }
  });
  connectionList.value.forEach((conn) => {
    const index = stepConnectionList.value.findIndex(
      (stepCon) => JSON.stringify(stepCon.connection) === JSON.stringify(value)
    );
    if (
      conn.name.toLowerCase().replaceAll(" ", "") ===
        value.name.toLowerCase().replaceAll(" ", "") &&
      index < 0
    ) {
      selectedCreateConnection.value.nameExists = true;
    }
  });
}

function findConnectionName(stepConnection: StepConnection): string {
  let targetConnection;
  if (stepConnection.connectionId) {
    targetConnection = selectedOrganizationConnections.value.find(
      (connection) => connection.id === stepConnection.connectionId
    );
  }
  return targetConnection ? targetConnection.name : "";
}

function generateKey(key1, key2) {
  if (key2) {
    return key2;
  }
  return key1;
}

watch(
  () => selectedCreateConnection.value.selectedName,
  () => {
    if (selectedCreateConnection.value.selectedName !== "") {
      selectedCreateConnection.value.connection = connectionList.value.find(
        (conn) => conn.name === selectedCreateConnection.value.selectedName
      );
      selectedCreateConnection.value.uniqueConnection = false;
      isCreateConnectionValid.value = true;
    }
  }
);

watch(
  () => selectedOrganization.value,
  async () => {
    if (selectedOrganization.value) {
      flowNameExists.value = "";
      flowNameLoading.value = true;
      // The previous organization's result must not count for this one while its verify is pending.
      isConnectorsValid.value = {
        verified: false,
        list: [],
        connectionOptionalSpecIds: [],
      };
      const { current, response: verifyResult } =
        await verifyConnectorsForSelection();
      if (current) {
        isConnectorsValid.value = verifyResult;
      }
      checkFlowNameExists(
        selectedOrganization.value.id,
        selectedFlow.value.name
      ).then((response) => {
        flowNameExists.value = response;
        flowNameLoading.value = false;
      });
    } else {
      flowNameExists.value = "";
    }
  },
  { deep: true }
);

watch(
  () => active.value,
  async () => {
    if (active.value === 1 && selectedOrganization.value) {
      verifying.value = true;
      const { current, response } = await verifyConnectorsForSelection();
      if (current) {
        if (response) {
          isConnectorsValid.value = response;
          verifying.value = false;
        } else {
          verifyError.value = true;
        }
      } else {
        // A newer verify owns the result; don't leave this one's spinner running.
        verifying.value = false;
      }
    }
    if (active.value === 2 && isConnectorsValid.value.verified) {
      stepConnectionList.value = [];
      organizationConnections.value = await getOrganizationConnectionList(
        selectedOrgId.value
      );
      // The gateway decides which specs are connection-optional (OT-5175).
      const connectionOptionalSpecIds = new Set(
        isConnectorsValid.value.connectionOptionalSpecIds || []
      );
      selectedFlow.value.steps.forEach((step) => {
        const list = organizationConnections?.value.filter(
          (connection) =>
            connection.connector.connectorSpecId === step.connectorSpecId
        );
        selectedOrganizationConnections.value = organizationConnections?.value;
        // LOOP / LOOP_END are virtual steps with no connector, so they need no connection mapping.
        const isVirtualStep = step.type === "LOOP" || step.type === "LOOP_END";
        // A connection-optional step needs no connection mapping in the target org. The connector
        // spec decides, even when the step still carries a legacy connection; a step with only a
        // connectorSpecId stays optional too (pre-OT-5175 behaviour, and older gateways send no list).
        const connectionOptional =
          connectionOptionalSpecIds.has(step.connectorSpecId) ||
          (!step.connection && !!step.connectorSpecId);
        const requiresCreate =
          isVirtualStep || connectionOptional ? false : list.length === 0;
        stepConnectionList.value.push({
          stepId: step.id,
          stepName: step.name,
          specId: step.connectorSpecId,
          requiresCreate,
          connectionId: "",
          addNew: false,
          connection: undefined,
          nameExists: false,
          uniqueConnection: false,
          selectedName: "",
          connectionOptional,
          isVirtualStep,
        });
      });
    }

    if (active.value === 3) {
      newConnectionLoading.value = true;
      if (createConnectionList.value.length !== 0) {
        await getOrganizationsConnectorList().then((connectorListDB) => {
          if (connectorListDB) {
            connectorList.value = connectorListDB;
          }
        });
        selectedStepConnectionIndex.value = 0;
        // eslint-disable-next-line prefer-destructuring
        selectedCreateConnection.value = createConnectionList.value[0];
      } else {
        active.value++;
      }
      newConnectionLoading.value = false;
    }
  }
);

onBeforeMount(async () => {
  pageLoading.value = true;
  if (flowId && version) {
    loading.value = true;
    await getFlow(flowId, version).then((response) => {
      if (response) {
        selectedFlow.value = {
          ...response,
          steps: getAllSteps(response.steps),
        };
        loading.value = false;
      } else {
        flowError.value = true;
      }
    });
  } else {
    flowError.value = true;
  }
  if (authInfo.value.userId && !flowError.value) {
    await getOrganizationsByUserId(authInfo.value.userId).then((response) => {
      if (response) {
        organizations.value = response.map((x) => {
          x.disabled = authInfo.value.organizationId === x.id;

          return x;
        });
      } else {
        userError.value = true;
      }
    });
  } else {
    userError.value = true;
  }
  pageLoading.value = false;
});

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(), _createBlock(_unref(ElSteps), {
          active: active.value,
          "align-center": "",
          key: createConnectionList.value.length,
          style: {"padding-top":"5px"}
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(ElStep), {
              title: _unref(t)('Common.Organization'),
              id: "step-1",
              class: "cursor-pointer",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (setActive(0)))
            }, null, 8, ["title"]),
            _createVNode(_unref(ElStep), {
              title: _unref(t)('Common.Connectors'),
              class: "cursor-pointer",
              id: "step-2",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (setActive(1)))
            }, null, 8, ["title"]),
            _createVNode(_unref(ElStep), {
              title: _unref(t)('Common.ConnectionMap'),
              class: "cursor-pointer",
              id: "step-3",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (setActive(2)))
            }, null, 8, ["title"]),
            _createVNode(_unref(ElStep), {
              title: _unref(t)('Common.NewConnection'),
              id: "step-4",
              class: "cursor-pointer",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (setActive(3)))
            }, null, 8, ["title"]),
            _createVNode(_unref(ElStep), {
              title: _unref(t)('Common.Finish'),
              id: "step-5",
              class: "cursor-pointer",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (setActive(4)))
            }, null, 8, ["title"])
          ]),
          _: 1
        }, 8, ["active"]))
      ]),
      (
          (pageLoading.value && active.value === 0) ||
          (newConnectionLoading.value && active.value === 3)
        )
        ? (_openBlock(), _createElementBlock("div", _hoisted_4))
        : _createCommentVNode("", true),
      (active.value === 0 && !pageLoading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", null, [
              _createElementVNode("span", null, _toDisplayString(_unref(t)("Flow.Guide")), 1),
              _hoisted_6,
              _createElementVNode("span", null, _toDisplayString(_unref(t)("Flow.WizardFirst")), 1),
              _createTextVNode("  "),
              _createVNode(_unref(ElSelect), {
                modelValue: selectedOrgId.value,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((selectedOrgId).value = $event)),
                id: "organization-select",
                placeholder: _unref(t)('Header.SelectOrganization')
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(organizations.value, (organization, index) => {
                    return (_openBlock(), _createBlock(_unref(ElOption), {
                      id: 'organization-option-' + index,
                      key: organization.id,
                      label: organization.name,
                      value: organization.id,
                      disabled: organization.disabled
                    }, null, 8, ["id", "label", "value", "disabled"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue", "placeholder"]),
              _createElementVNode("span", null, _toDisplayString(_unref(t)("Common.Organization").toLowerCase()) + ". ", 1),
              _hoisted_7,
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _withDirectives(_createElementVNode("span", { style: {"min-height":"20px"} }, _toDisplayString(_unref(t)("Flow.CheckExist")), 513), [
                    [_vShow, flowNameLoading.value]
                  ]),
                  (flowNameLoading.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        _createElementVNode("img", {
                          src: `${_unref(ASSETS_BASE_URL)}/${_unref(DEFAULT_LOGO)}.png`,
                          alt: "Loading...",
                          class: "loader-logo-25"
                        }, null, 8, _hoisted_11)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _withDirectives(_createElementVNode("span", _hoisted_12, [
                  _createVNode(_component_font_awesome_icon, {
                    class: "color-red",
                    icon: "info-circle"
                  }),
                  _createTextVNode("  " + _toDisplayString(_unref(t)("Flow.SameName")), 1)
                ], 512), [
                  [_vShow, flowNameExists.value === 'EXIST']
                ])
              ])
            ])
          ]))
        : (active.value === 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              (verifying.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _createElementVNode("span", null, _toDisplayString(_unref(t)("Flow.Verifying")), 1),
                    (verifying.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                          _createElementVNode("img", {
                            src: `${_unref(ASSETS_BASE_URL)}/${_unref(DEFAULT_LOGO)}.png`,
                            alt: "Loading...",
                            class: "loader-logo-25"
                          }, null, 8, _hoisted_16)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : (isConnectorsValid.value.verified)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                      _createElementVNode("span", null, _toDisplayString(_unref(t)("Flow.Verified")) + " " + _toDisplayString(_unref(t)("Flow.Continue")), 1)
                    ]))
                  : (!isConnectorsValid.value.verified)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                        (_unref(hasPermission)('ORGANIZATIONS.LIST.EDIT'))
                          ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(_unref(t)("Flow.AddConnector")), 1))
                          : (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(_unref(t)("Flow.NoPermissionConnector")), 1)),
                        _createElementVNode("div", _hoisted_21, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(isConnectorsValid.value.list, (connector) => {
                            return (_openBlock(), _createElementBlock("span", {
                              key: connector.id
                            }, _toDisplayString(connector.name), 1))
                          }), 128))
                        ])
                      ]))
                    : _createCommentVNode("", true)
            ]))
          : (active.value === 2)
            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                _createElementVNode("span", null, _toDisplayString(connectionRequiredSteps.value.length > 0 &&
          createConnectionList.value.length === connectionRequiredSteps.value.length
            ? _unref(t)("Flow.NewConnection")
            : _unref(t)("Flow.ConnectionGuide")), 1),
                _createElementVNode("div", _hoisted_23, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(stepConnectionList.value, (element, index) => {
                    return (_openBlock(), _createElementBlock(_Fragment, {
                      key: element.stepId
                    }, [
                      (!element.isVirtualStep)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: _normalizeClass(["d-flex flex-row", index !== 0 ? 'margin-top-10' : '']),
                            style: {"min-height":"41px"}
                          }, [
                            _createElementVNode("div", _hoisted_24, [
                              _createElementVNode("span", null, _toDisplayString(element.stepName), 1)
                            ]),
                            (element.connectionOptional)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                  _createElementVNode("span", null, [
                                    _createVNode(_component_font_awesome_icon, {
                                      class: "color-green",
                                      icon: "check"
                                    }),
                                    _createTextVNode(" " + _toDisplayString(_unref(t)("Flow.NoConnectionNeeded")), 1)
                                  ])
                                ]))
                              : (!element.requiresCreate)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                    _createVNode(_unref(ElSelect), {
                                      modelValue: element.connectionId,
                                      "onUpdate:modelValue": ($event: any) => ((element.connectionId) = $event),
                                      disabled: element.addNew,
                                      id: 'connection-select-' + index
                                    }, {
                                      default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedOrganizationConnections.value.filter(
                      (con) => con.connector.connectorSpecId === element.specId
                    ), (connection, indexOption) => {
                                          return (_openBlock(), _createBlock(_unref(ElOption), {
                                            key: connection.id,
                                            id: 'connection-select-' + index + '-option' + indexOption,
                                            label: connection.name,
                                            value: connection.id
                                          }, null, 8, ["id", "label", "value"]))
                                        }), 128))
                                      ]),
                                      _: 2
                                    }, 1032, ["modelValue", "onUpdate:modelValue", "disabled", "id"]),
                                    _createElementVNode("div", _hoisted_27, [
                                      _withDirectives(_createElementVNode("input", {
                                        type: "checkbox",
                                        id: 'check-' + index,
                                        "onUpdate:modelValue": ($event: any) => ((element.addNew) = $event)
                                      }, null, 8, _hoisted_28), [
                                        [_vModelCheckbox, element.addNew]
                                      ]),
                                      _createElementVNode("label", {
                                        for: 'check-' + index,
                                        class: "margin-left-3 d-flex align-items-center"
                                      }, [
                                        _createElementVNode("span", null, _toDisplayString(_unref(t)("Common.AddNew")), 1)
                                      ], 8, _hoisted_29)
                                    ])
                                  ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                    _createElementVNode("span", null, [
                                      _createVNode(_component_font_awesome_icon, {
                                        class: "color-warning",
                                        icon: "info-circle"
                                      }),
                                      _createTextVNode(" " + _toDisplayString(_unref(t)("Flow.NewConnection")), 1)
                                    ])
                                  ]))
                          ], 2))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true),
      (active.value === 3 && !newConnectionLoading.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 4,
            class: _normalizeClass(["card-body overflow-y", 
          createConnectionList.value.length === 0
            ? 'd-flex flex-column align-items-center justify-content-center'
            : ''
        ])
          }, [
            (createConnectionList.value.length !== 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                  _createElementVNode("div", _hoisted_32, [
                    _createElementVNode("div", _hoisted_33, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(createConnectionList.value, (create) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: _normalizeClass(["tab", 
                  create.stepId === selectedCreateConnection.value.stepId
                    ? 'active-tab'
                    : ''
                ]),
                          key: create.stepId
                        }, [
                          _createVNode(_component_font_awesome_icon, {
                            class: _normalizeClass({
                    'color-green': create.connection,
                    'color-grey': !create.connection,
                    'color-blue':
                      selectedCreateConnection.value.stepId === create.stepId,
                  }),
                            icon: create.connection ? 'check' : 'circle'
                          }, null, 8, ["class", "icon"]),
                          _createTextVNode("  "),
                          _createElementVNode("label", _hoisted_34, _toDisplayString(create.stepName), 1)
                        ], 2))
                      }), 128))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_35, [
                    _createElementVNode("div", _hoisted_36, [
                      _createElementVNode("div", _hoisted_37, [
                        _createElementVNode("div", _hoisted_38, [
                          (
                      connectionList.value.filter(
                        (conn) =>
                          conn.connector.connectorSpecId ===
                            selectedCreateConnection.value.specId &&
                          conn.idx !== selectedStepConnectionIndex.value
                      ).length > 0
                    )
                            ? (_openBlock(), _createBlock(_unref(ElSelect), {
                                key: 0,
                                modelValue: selectedCreateConnection.value.selectedName,
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((selectedCreateConnection.value.selectedName) = $event)),
                                id: "select-existing-connection",
                                placeholder: _unref(t)('Flow.SelectExistingConnection')
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(connectionList.value.filter(
                        (conn) =>
                          conn.connector.connectorSpecId ===
                            selectedCreateConnection.value.specId &&
                          conn.idx !== selectedStepConnectionIndex.value
                      ), (connection, index) => {
                                    return (_openBlock(), _createBlock(_unref(ElOption), {
                                      key: connection.name,
                                      label: connection.name,
                                      id: 'connection-option-' + index,
                                      value: connection.name
                                    }, null, 8, ["label", "id", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue", "placeholder"]))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("img", {
                          class: "logo-l",
                          src: `${_unref(ASSETS_BASE_URL)}/${
                    selectedCreateConnection.value.specId
                  }${_unref(getResolution)(false)}.png`,
                          alt: selectedCreateConnection.value.specId
                        }, null, 8, _hoisted_39)
                      ]),
                      (!selectedCreateConnection.value?.selectedName)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                            (
                    selectedCreateConnection.value.stepId &&
                    !selectedCreateConnection.value.selectedName
                  )
                              ? (_openBlock(), _createBlock(_unref(ConnectionForm), {
                                  index: selectedStepConnectionIndex.value,
                                  "step-connection": selectedCreateConnection.value,
                                  key: 
                    generateKey(
                      selectedCreateConnection.value.stepId,
                      selectedCreateConnection.value.selectedName
                    )
                  ,
                                  "spec-id": selectedCreateConnection.value.specId,
                                  connectors: connectorList.value,
                                  "old-connection": selectedCreateConnection.value.connection,
                                  "name-exist": selectedCreateConnection.value.nameExists,
                                  selectedOrgId: selectedOrgId.value,
                                  onCheckName: _cache[7] || (_cache[7] = ($event: any) => (checkNameExists($event))),
                                  onUpdate: updateConnection,
                                  onUpdateConnectionValid: updateCreateConnectionValid
                                }, null, 8, ["index", "step-connection", "spec-id", "connectors", "old-connection", "name-exist", "selectedOrgId"]))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_41, [
                        (selectedStepConnectionIndex.value !== 0)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              id: "connection-previous",
                              class: "btn-link btn",
                              disabled: selectedStepConnectionIndex.value === 0,
                              onClick: previousConnection
                            }, _toDisplayString(_unref(t)("Common.Previous")), 9, _hoisted_42))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_43, [
                  _createElementVNode("span", null, _toDisplayString(_unref(t)("Flow.Continue")), 1)
                ]))
          ], 2))
        : _createCommentVNode("", true),
      (active.value === 4)
        ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
            _createElementVNode("label", _hoisted_45, [
              _createElementVNode("span", null, [
                _createElementVNode("strong", null, _toDisplayString(_unref(t)("Flow.FinishText")), 1)
              ])
            ]),
            _hoisted_46,
            _createElementVNode("div", null, [
              _createElementVNode("label", _hoisted_47, [
                _createElementVNode("span", null, [
                  _createElementVNode("strong", _hoisted_48, _toDisplayString(_unref(t)("Flow.FlowName")), 1),
                  _createTextVNode(" : " + _toDisplayString(selectedFlow.value.name.length > 100
                  ? `${selectedFlow.value.name.slice(0, 100)}...`
                  : selectedFlow.value.name), 1)
                ])
              ]),
              _hoisted_49,
              _createElementVNode("label", _hoisted_50, [
                _createElementVNode("span", _hoisted_51, [
                  _createElementVNode("strong", _hoisted_52, _toDisplayString(_unref(t)("Common.Target")) + " " + _toDisplayString(_unref(t)("Common.Organization")), 1),
                  _createTextVNode(": " + _toDisplayString(selectedOrganization.value ? selectedOrganization.value.name : ""), 1)
                ])
              ]),
              _hoisted_53,
              _createElementVNode("label", _hoisted_54, [
                _createElementVNode("span", null, [
                  _createElementVNode("strong", null, _toDisplayString(_unref(t)("Flow.StepsAndConnections")), 1)
                ])
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(stepConnectionList.value, (step) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: step.stepId
                }, [
                  (!step.isVirtualStep)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                        _createElementVNode("label", null, [
                          _createElementVNode("span", null, [
                            _createElementVNode("strong", _hoisted_56, _toDisplayString(step.stepName), 1),
                            _createTextVNode(" : " + _toDisplayString(step.connectionId
                      ? findConnectionName(step)
                      : step.connection?.name ?? _unref(t)("Flow.NoConnectionNeeded")), 1)
                          ])
                        ]),
                        _hoisted_57
                      ]))
                    : _createCommentVNode("", true)
                ], 64))
              }), 128)),
              _createElementVNode("div", _hoisted_58, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  id: "go-flow-check",
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((goEdit).value = $event))
                }, null, 512), [
                  [_vModelCheckbox, goEdit.value]
                ]),
                _createElementVNode("label", _hoisted_59, [
                  _createElementVNode("span", null, _toDisplayString(_unref(t)("Flow.GoFlow")), 1)
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_60, [
        _createElementVNode("div", _hoisted_61, [
          _createElementVNode("div", null, [
            (selectedFlow.value && active.value !== 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_62, [
                  _createElementVNode("strong", _hoisted_63, _toDisplayString(_unref(t)("Flow.FlowName")), 1),
                  _createTextVNode(" : " + _toDisplayString(selectedFlow.value.name.length > 100
                  ? `${selectedFlow.value.name.slice(0, 100)}...`
                  : selectedFlow.value.name), 1)
                ]))
              : _createCommentVNode("", true),
            _hoisted_64,
            (active.value !== 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_65, [
                  _createElementVNode("strong", _hoisted_66, _toDisplayString(_unref(t)("Common.Target")) + " " + _toDisplayString(_unref(t)("Common.Organization")), 1),
                  _createTextVNode(": " + _toDisplayString(selectedOrganization.value ? selectedOrganization.value.name : ""), 1)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", null, [
            _createVNode(_unref(ElButton), {
              id: "cancel-button",
              class: "btn-oneTeg3",
              onClick: _cache[9] || (_cache[9] = ($event: any) => (cancel()))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)("Common.Cancel")), 1)
              ]),
              _: 1
            }),
            (active.value !== 0)
              ? (_openBlock(), _createBlock(_unref(ElButton), {
                  key: 0,
                  id: "previous-button",
                  class: "btn-oneTeg3",
                  disabled: active.value === 0,
                  onClick: previous
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)("Common.Previous")), 1)
                  ]),
                  _: 1
                }, 8, ["disabled"]))
              : _createCommentVNode("", true),
            (active.value !== 4)
              ? (_openBlock(), _createBlock(_unref(ElButton), {
                  key: 1,
                  id: "next-button",
                  class: "btn-oneTeg2",
                  disabled: !isStepsValid.value,
                  onClick: next
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)("Common.Next")), 1)
                  ]),
                  _: 1
                }, 8, ["disabled"]))
              : (_openBlock(), _createBlock(_unref(ElButton), {
                  key: 2,
                  id: "finish-button",
                  class: "btn-oneTeg2",
                  disabled: !isStepsValid.value,
                  onClick: finishExportWizard
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)("Common.Finish")), 1)
                  ]),
                  _: 1
                }, 8, ["disabled"]))
          ])
        ])
      ])
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_67, [
      _createElementVNode("img", {
        src: `${_unref(ASSETS_BASE_URL)}/${_unref(DEFAULT_LOGO)}.png`,
        alt: "Loading...",
        class: "loader-logo-40"
      }, null, 8, _hoisted_68)
    ], 512), [
      [_vShow, pageLoading.value || newConnectionLoading.value || exportResponseLoading.value]
    ])
  ]))
}
}

})